import React from "react";
import Button from "../Button/Button"
import styles from "./SplashPage.scss";

const SplashPage = (props) => {
    const { data } = props;
    return (
        <>
            <div className="splash-page" style={{ background: `url(${data.backgroundImage})`, backgroundSize: "contain" }}>
                <div className="splash-gradient">
                    <div className="splash-content">
                        <p>{data.title}</p>
                        <div className="splashPath">
                            <img src={data.pathImage} alt={data.title} />
                        </div>
                        <Button text={data.buttonText} onClick={() => {
                            if (props.onComplete) {
                                props.onComplete()
                            }
                        }} />
                        <div className="content-satellite">
                            <img src={data.contentImage} alt={data.title} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SplashPage;
